import { useEffect, useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectFade, Pagination } from 'swiper/modules';
import type { Swiper as SwiperType } from 'swiper';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/pagination';

const HeroSlider = () => {
  const swiperRef = useRef<SwiperType | null>(null);
  const [activeIndex, setActiveIndex] = useState(0);

  const slides = [
    {
      image: 'https://static.readdy.ai/image/853dbb08f880e8122464f2674851b25b/a6bd1db7d5165123308a4adc77506b8c.png',
      title: '마음의 평화를 찾는 곳',
      subtitle: '성덕사'
    },
    {
      image: 'https://public.readdy.ai/ai/img_res/a67ac6888de5cd073a012bebc8e866d6.jpg',
      title: '부처님의 가르침이 있는',
      subtitle: '성덕사'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Korean%20Buddhist%20temple%20meditation%20hall%20interior%20with%20Buddha%20statue%2C%20soft%20natural%20lighting%20through%20traditional%20windows%2C%20peaceful%20ambiance%2C%20clean%20simple%20background%2C%20spiritual%20atmosphere%2C%20high%20quality%20photography&width=1920&height=1080&seq=temple3&orientation=landscape',
      title: '깨달음의 길로 안내하는',
      subtitle: '성덕사'
    }
  ];

  return (
    <div className="relative h-[80vh] md:h-[90vh] w-full mt-20">
      <Swiper
        modules={[Autoplay, EffectFade, Pagination]}
        effect="fade"
        speed={800}
        autoplay={{
          delay: 4000,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
          bulletClass: 'swiper-pagination-bullet !bg-white/60',
          bulletActiveClass: 'swiper-pagination-bullet-active !bg-white',
        }}
        loop={true}
        fadeEffect={{
          crossFade: true
        }}
        onSwiper={(swiper) => {
          swiperRef.current = swiper;
        }}
        onSlideChange={(swiper) => {
          setActiveIndex(swiper.realIndex);
        }}
        className="h-full w-full"
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <div className="relative h-full w-full">
              <img
                src={slide.image}
                alt={slide.title}
                className="absolute inset-0 w-full h-full object-contain"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
              
              <div className="absolute inset-0 flex items-center justify-center z-10">
                <div className="text-center text-white px-6">
                  <h1 className="text-5xl md:text-7xl font-serif font-bold mb-4 animate-fade-in drop-shadow-2xl">
                    {slide.title}
                  </h1>
                  <p className="text-3xl md:text-5xl font-serif animate-fade-in-delay drop-shadow-2xl">
                    {slide.subtitle}
                  </p>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      <style>{`
        @keyframes fade-in {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .animate-fade-in {
          animation: fade-in 1s ease-out;
        }

        .animate-fade-in-delay {
          animation: fade-in 1s ease-out 0.3s both;
        }

        .swiper-pagination {
          bottom: 40px !important;
        }

        .swiper-pagination-bullet {
          width: 12px !important;
          height: 12px !important;
          margin: 0 6px !important;
          opacity: 1 !important;
        }

        .swiper-slide {
          opacity: 0 !important;
        }

        .swiper-slide-active {
          opacity: 1 !important;
        }
      `}</style>
    </div>
  );
};

export default HeroSlider;
